import { render, staticRenderFns } from "./ConsultasDocsGeral.vue?vue&type=template&id=4e5937d9&scoped=true&lang=pug&"
import script from "./ConsultasDocsGeral.vue?vue&type=script&lang=js&"
export * from "./ConsultasDocsGeral.vue?vue&type=script&lang=js&"
import style0 from "./ConsultasDocsGeral.vue?vue&type=style&index=0&id=4e5937d9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5937d9",
  null
  
)

export default component.exports